import { SVGProps } from "react";

export default function CheckCircleFilledIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 24, width = 24, fill = "#E3592E", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9984 21.6004C17.3004 21.6004 21.5984 17.3023 21.5984 12.0004C21.5984 6.69846 17.3004 2.40039 11.9984 2.40039C6.6965 2.40039 2.39844 6.69846 2.39844 12.0004C2.39844 17.3023 6.6965 21.6004 11.9984 21.6004ZM16.6263 9.82975C16.9187 9.42776 16.8298 8.86488 16.4278 8.57253C16.0258 8.28017 15.4629 8.36905 15.1706 8.77104L10.9901 14.5192L8.73483 12.264C8.38336 11.9125 7.81351 11.9125 7.46204 12.264C7.11057 12.6155 7.11057 13.1853 7.46204 13.5368L10.462 16.5368C10.6482 16.7229 10.9064 16.8182 11.1688 16.7976C11.4312 16.777 11.6715 16.6426 11.8263 16.4297L16.6263 9.82975Z"
        fill={fill}
      />
    </svg>
  );
}
